import React, { useEffect, useState, useCallback } from "react";
import { useLang } from "../../context/langProvider";
import "./styles.css";
import CarouselActivity from "../CarouselActivity";
import FormActivity from "../FormActivity";
export default function GestionActivity() {
  const [parentId, setParentId] = useState("");
  const [mainActivities, setMainActivities] = useState([]);
  const [showForm, setShowForm] = useState(false);

  const { lang } = useLang();

  const refreshMainActivities = useCallback(() => {
    return fetch(
      "https://intereseaux-api.bonnardwebeditions.fr/api/activities?lang=" + lang,
      { method: "GET" }
    )
      .then((res) => res.json())
      .then((data) => setMainActivities(data))
      .catch((err) => console.error("Erreur chargement activités :", err));
  }, [lang]);

  useEffect(() => {
    refreshMainActivities();
  }, [refreshMainActivities]);



  const selectedActivity = mainActivities.find(
    (activity) => String(activity.id) === String(parentId)
  );

  return (
    <section className="activities-section">
      <h1>
        {selectedActivity == null
          ? "GESTION DES ACTIVITÉS PRINCIPALES"
          : `GESTION DES SOUS ACTIVITÉS`}
      </h1>
      {
        selectedActivity == null&&(
          <>
          <CarouselActivity activities={mainActivities} refresh={refreshMainActivities} selectCategory={setParentId} addActivity={setShowForm}/>
          </>
            
        )
        
      }
      {
        selectedActivity != null&&(
          <>
          <div className="container-main-card ">
            <div className="card-main-activity-selected background-primary">
              <div className="card-activity-header">
                {selectedActivity.name}
              </div>
              <div className="card-activity-controls">
                <button onClick={()=>setParentId(null)}>RETOUR</button>
              </div>
              
            </div>
          </div>

          
            <CarouselActivity activities={selectedActivity.sousCategories} refresh={refreshMainActivities} selectCategory={setParentId} isMainActivities={false} addActivity={setShowForm}/>
            
          </>
        )
      }
      <FormActivity open={showForm} idParentActivity={parentId} refresh={refreshMainActivities} onClose={()=>setShowForm(false)} />
    </section>
    
  );
}
